import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdvisorProjectProvider } from '../contexts/AdvisorProjectContext';

/** Shared project context for org advisor portal pages (switcher, filtered lists, magic links). */
export default function AdvisorPortalLayout() {
  return (
    <AdvisorProjectProvider>
      <Outlet />
    </AdvisorProjectProvider>
  );
}
